import { toast } from "react-toastify";
import {request} from "../../utils/request";
import { accidentAction } from "../slices/accidentSlice";
import axios from "axios";

export function loginUser(credentials, navigate) {
    return async (dispatch) => {
        try{
            const response = await request.post("/auth/login", credentials, {
                headers: {
                    "Content-Type": "application/json",
                  },
            });
            const { token, user, admin } = response.data;
            console.log(response.data);
            
            sessionStorage.setItem("token", user.token);
            sessionStorage.setItem("role", user.role);
            console.log("Role:", user.role); 
            sessionStorage.setItem("user", JSON.stringify(user))
            sessionStorage.setItem("admin", JSON.stringify(admin))
            
            toast.success("Anmeldung war erfolgreich!"); 
            navigate("/");
        } catch (error) {
            console.error("Login error:", error);
            toast.error(error.response?.data?.message || "Anmeldung nicht geklappt  ");
          }
        };
    }


    export function createComment(comment, userId) {
        return async (dispatch) => {
          try {
            const token = sessionStorage.getItem("token");
            dispatch(accidentAction.setCreateLoading(true));
            await request.post(
              `/comments`,
              { text: comment, user: userId },
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
      
            toast.success("Die Notiz wurde hinzugefügt.");
            dispatch(accidentAction.setComment(""));
          } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message);
          } finally {
            dispatch(accidentAction.setCreateLoading(false));
          }
        };
      }

      export function getAccidentById(id) {
        return async (dispatch) => {
          try {
            const token = sessionStorage.getItem("token");
            dispatch(accidentAction.setCreateLoading(true));
            const {data}=await request.get(
              `/accidents/${id}`,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
              dispatch(accidentAction.setLastAccident(data.accident));
          } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message || " Es ist ein Fehler beim Hinzufügen der Notiz aufgetreten.");
          } finally {
            dispatch(accidentAction.setCreateLoading(false));
          }
        };
      }
      
  
      export function createPhotoForAccident(formData, who) {
        
        return async (dispatch) => {
            try {
              const token = sessionStorage.getItem("token");
                dispatch(accidentAction.setCreatePhotoLoading(true));
                const { data } = await request.post(
                    `/photos`,
                    formData,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",  // Change content type for FormData
                        },
                    }
                );
                console.log("dt = ",data);
                
                if(who==="partner"){
                  dispatch(accidentAction.addPhotoToPartner(data));
                }else { 
                  dispatch(accidentAction.addPhotoToLastAccident(data));
                }
    
                toast.success("Bild wurde erfolgreich hochgeladen");
            } catch (error) {
                toast.error(error.response?.data?.message);
            } finally {
                dispatch(accidentAction.setCreatePhotoLoading(false));
            }
        };
    }

  
    
    export function getAllAccident(currentPage, PerPage) {
      return async (dispatch) => {
        
        dispatch(accidentAction.setGetLoading(true)); 
        try {
          
          const token = sessionStorage.getItem('token'); 
          const res = await request.get(`/accidents?page=${currentPage}&perPage=${PerPage}`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          });
          dispatch(accidentAction.setAccidents(res.data));
          dispatch(accidentAction.setNumberOfAuftrage(res.data.documentCount));
        
        } catch (error) {
          console.log(error);
          toast.error(error.response?.data?.message); 
        } finally {
          dispatch(accidentAction.setGetLoading(false)); 
        }
      };
    }

    export function getAllPartner(currentPage, PerPage) {
      return async (dispatch) => {
        dispatch(accidentAction.setGetLoading(true)); 
        console.log(currentPage, "  thisssss  ", PerPage);
        
        try {
          const token = sessionStorage.getItem('token'); 
          let res;
          console.log("Fetching users with pagination:", { currentPage, PerPage });
         if(currentPage && PerPage){
           res = await request.get(`/users?page=${currentPage}&perPage=${PerPage}`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          });
         }else{
          res = await request.get(`/users`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          });
         }
          dispatch(accidentAction.setAccidents(res.data));
          dispatch(accidentAction.setNumberOfAccident(res.data.documentCount));
          
        } catch (error) {
          toast.error(error.response?.data?.message || "Es ist ein Fehler beim Abrufen der Daten aufgetreten."); 
        } finally {
          dispatch(accidentAction.setGetLoading(false)); 
        }
      };
    }

export function getAllAdmin() {
      return async (dispatch) => {
        dispatch(accidentAction.setGetLoading(true)); 
        try {
          const token = sessionStorage.getItem('token'); 
          let res;
          res = await request.get(`/users?role=admin`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          });
         console.log(res);
         
          dispatch(accidentAction.setAccidents(res.data));
          dispatch(accidentAction.setNumberOfAccident(res.data.documentCount));
          
        } catch (error) {
          toast.error(error.response?.data?.message || "Es ist ein Fehler beim Abrufen der Daten aufgetreten."); 
        console.log(error.response?.data?.message || "Es ist ein Fehler beim Abrufen der Daten aufgetreten."); 
        } finally {
          dispatch(accidentAction.setGetLoading(false)); 
        }
      };
    }
    
    

    export function getOnePartner(id) {
      return async (dispatch) => {
        dispatch(accidentAction.setGetLoading(true));
        try {
          const token = sessionStorage.getItem('token');
          const res = await request.get(`/users/${id}`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          });
          dispatch(accidentAction.setPartner(res.data));
        } catch (error) {
          toast.error(error.response?.data?.message || "Es ist ein Fehler beim Abrufen der Partnerdaten aufgetreten."); 
        } finally {
          dispatch(accidentAction.setGetLoading(false));
        }
      };
    }
    

    export function createSignatureForAccident(formData, id, navigate) {
      return async (dispatch) => {
          try {
            const token = sessionStorage.getItem("token");
              dispatch(accidentAction.setCreatePhotoLoading(true));
              const { data } = await request.put(
                  `/accidents/${id}`, // Use photoId to specify which photo to update
                  formData,
                  {
                      headers: {
                          'Authorization': `Bearer ${token}`,
                          "Content-Type": "multipart/form-data",  // Keep content type for FormData
                      },
                  }
              );
  
              dispatch(accidentAction.addPhotoToLastAccident(data));
  
              toast.success("Die Unterschrift wurde erfolgreich hochgeladen.");
              navigate("/auftrage")
          } catch (error) {
              toast.error(error.response?.data?.message);
          } finally {
              dispatch(accidentAction.setCreatePhotoLoading(false));
          }
      };
  }

  export function createHochladenForAccident(formData, who) {
    return async (dispatch) => {
        try {
          const token = sessionStorage.getItem("token");
            dispatch(accidentAction.setCreatePhotoLoading(true));
            const { data } = await request.post(
                `/hochladens`, // Use photoId to specify which photo to update
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",  // Keep content type for FormData
                    },
                }
            );
            if(who === "partner"){
              dispatch(accidentAction.addHochladenPhotoToPartner(data));
            }else {
              dispatch(accidentAction.addHochladenPhoto(data));
            }
            toast.success("Der Upload wurde erfolgreich abgeschlossen.");
        } catch (error) {
            toast.error(error.response?.data?.message || "Der Upload ist fehlgeschlagen.");
        } finally {
            dispatch(accidentAction.setCreatePhotoLoading(false));
        }
    };
}


export function deleteHochladen(id, who) {
  return async (dispatch) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem("token");
      const res = await request.delete(`/hochladens/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      if(who==="partner"){
        dispatch(accidentAction.removeHochladenPhotoFromPartner(id));
      }else { 
        dispatch(accidentAction.removeHochladenPhoto(id));
      }
      toast.success("deleted successfully");
    } catch (error) {
      toast.error(error.response?.data?.message); 
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}
export const deletePhotoForAccident = (photoId) => async (dispatch) => {
  try {
    await request.delete(`/photos/${photoId}`);
      dispatch(accidentAction.removePhotoFromLastAccident(photoId));
  } catch (error) {
      console.error("Error deleting photo:", error);
      throw error;
  }
};
export function createCommentForAccident(title, comment, accidentId) {
  return async (dispatch) => {
    try {
      const token = sessionStorage.getItem("token");

      if (!comment || typeof comment !== "string") {
        console.error("Error: Comment must be a valid string.");
        toast.error("Kommentar darf nicht leer sein.");
        return;
      }

      if (!title || typeof title !== "string") {
        toast.error("Titel darf nicht leer sein.");
        return;
      }

      if (!accidentId) {
        console.error("Error: Accident ID is required.");
        toast.error("Unfall-ID ist erforderlich.");
        return;
      }

      if (!token) {
        console.error("Error: No authentication token found.");
        toast.error("Authentifizierung fehlgeschlagen.");
        return;
      }

      dispatch(accidentAction.setCreateLoading(true));

      const { data } = await request.post(
        `/comments`,
        { 
          text: String(comment),
          title: String(title),
          accident: accidentId 
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch(accidentAction.addCommentForAccident(data));
      toast.success("Eingefügt");
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Es ist ein Fehler beim Hinzufügen der Notiz aufgetreten.");
    } finally {
      dispatch(accidentAction.setCreateLoading(false));
    }
  };
}

export function createCommentForPartner(comment, userId, title) {
  return async (dispatch, getState) => {  
    try {
      const token = sessionStorage.getItem("token");
      dispatch(accidentAction.setCreateLoading(true));
      let partner = getState().accident.partner;
      
      let partnerId = partner ? partner._id : null;

      const { data } = await request.post(
        `/comments`,
        { text: comment, user: userId, title },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch(accidentAction.addCommentForPartner(data));
      const updatedState = getState();
      console.log("Redux State after adding comment:", updatedState.accident.partner.user.notes);
      if (partnerId) {
        dispatch(getCommentsForPartner(partnerId));
      } else {
        console.warn("❌ partnerId ist undefiniert, das Abrufen von Kommentaren wird übersprungen.");
      }

      toast.success("Uploaded successfully");
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Beim Hinzufügen der Notiz ist ein Fehler aufgetreten.");
    } finally {
      dispatch(accidentAction.setCreateLoading(false));
    }
  };
}


export const getCommentsForPartner = (partnerId) => async (dispatch, getState) => {
  try {
    if (!partnerId) {
      const state = getState();
      partnerId = state.accident.partner?._id;
    }

    if (!partnerId) {
      console.error("❌ Partner ID is missing!");
      return;
    }

    const response = await axios.get(`/api/comments/partner/${partnerId}`);
    dispatch(accidentAction.setPartner({
      ...getState().accident.partner,
      user: { 
        ...getState().accident.partner.user, 
        notes: response.data.notes 
      }
    }));

  } catch (error) {
    console.error("Error fetching comments:", error);
  }
};

export function deleteComment(id, who) {
  return async (dispatch, getState) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem("token");
      await request.delete(`/comments/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      if (who === "partner") {
        const currentNotes = getState().accident.partner.user.notes;
        const updatedNotes = currentNotes.filter(note => note._id !== id);

        dispatch(accidentAction.setPartner({
          ...getState().accident.partner,
          user: {
            ...getState().accident.partner.user,
            notes: updatedNotes
          }
        }));
      } else {
        dispatch(accidentAction.removeCommentForAccident(id));
      }

      toast.success("Erfolgreich gelöscht.");
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}
export function deletePhoto(id, who) {
  return async (dispatch, getState) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem("token");
      await request.delete(`/photos/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
        dispatch(accidentAction.removePhotoFromLastAccident(id));
      toast.success("Erfolgreich gelöscht.");
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}


export function deleteAccident(id) {
  return async (dispatch) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem("token");
      const res = await request.delete(`/accidents/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      dispatch(accidentAction.removeAccident(id))
      toast.success("erfolgreich gelöscht");
    } catch (error) {
      toast.error(error.response?.data?.message ); 
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}


export function updateAccident(id, updatedData, navigate) {
  return async (dispatch) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem("token");
      const res = await request.put(`/accidents/${id}`, updatedData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      dispatch(accidentAction.setLastAccident(res.data)); // Assuming your action updates the state with the new accident data
      toast.success("Erfolgreich aktualisiert.");
    } catch (error) {
      toast.error(error.response?.data?.message); 
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}

// export function downloadLastPdf(receiptId, invoiceNumber) {
//   return async (dispatch) => {
//     dispatch(accidentAction.setGetLoading(true)); // Activate loading state
//     try {
//       const token = sessionStorage.getItem('token');
//       const response = await request.get(`/accidents/full-accident/${receiptId}`, {
//         responseType: "blob",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       // Create a URL for the Blob
//       const url = window.URL.createObjectURL(new Blob([response.data]));

//       // Set up and trigger the download
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `${invoiceNumber}.pdf`);
//       document.body.appendChild(link);
//       link.click();

//       // Clean up after download
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Fehler beim Herunterladen der PDF-Datei:", error.response?.data?.message || error.message);
//       toast.error(error.response?.data?.message ); 
//     } finally {
//       dispatch(accidentAction.setGetLoading(false)); // Deactivate loading state
//     }
//   };
// }


// export function downloadWaiverPdf(receiptId, invoiceNumber) {
//   return async (dispatch) => {
//     dispatch(accidentAction.setGetLoading(true)); // Activate loading state
//     try {
//       const token = sessionStorage.getItem('token');
//       const response = await request.get(`/accidents/waiver-accident/${receiptId}`, {
//         responseType: "blob",
//         headers: {
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       // Create a URL for the Blob
//       const url = window.URL.createObjectURL(new Blob([response.data]));

//       // Set up and trigger the download
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `${invoiceNumber}.pdf`);
//       document.body.appendChild(link);
//       link.click();

//       // Clean up after download
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Error downloading PDF:", error.response|| error.message);
//       toast.error(error.response?.data?.message); 
//     } finally {
//       console.log("Function finished");
//       dispatch(accidentAction.setGetLoading(false)); // Deactivate loading state
//     }
//   };
// }

export function downloadLastPdf(receiptId, invoiceNumber) {
  return async (dispatch) => {
    // التحقق من صحة المعرف
    if (!receiptId) {
      toast.error("Datei-Upload fehlgeschlagen: Ungültige Beleg-ID.");
      return;
    }

    dispatch(accidentAction.setGetLoading(true)); // تفعيل التحميل

    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("❌ Fehler: Token nicht gefunden!");
        toast.error("Laden fehlgeschlagen: Token nicht gefunden.");
        dispatch(accidentAction.setGetLoading(false));
        return;
      }
      const response = await request.get(`/accidents/full-accident/${receiptId}`, {
        responseType: "blob", // تأكد من دعم الخادم لهذا النوع
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.data) {
        throw new Error("Die Antwort ist leer, bitte überprüfen Sie die Daten.");
      }

      // إنشاء رابط تحميل الملف
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoiceNumber}.pdf`);
      document.body.appendChild(link);
      link.click();

      // تنظيف الذاكرة بعد التحميل
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Beim Laden ist ein unerwarteter Fehler aufgetreten.";
      toast.error(errorMessage);
    } finally {
      dispatch(accidentAction.setGetLoading(false)); // إيقاف التحميل
    }
  };
}

export function downloadWaiverPdf(receiptId, invoiceNumber) {
    return async (dispatch) => {
        dispatch(accidentAction.setGetLoading(true)); // تفعيل التحميل
        try {
            const token = sessionStorage.getItem('token');
            if (!token) throw new Error("🔴 Token nicht gefunden! Bitte melde dich an.");

            if (!receiptId) throw new Error("🔴 Beleg-ID nicht gefunden!");
            if (!invoiceNumber) console.warn("⚠️ Warnung: Rechnungsnummer existiert nicht, es wird der Standardname verwendet.");

            const response = await request.get(`/accidents/waiver-accident/${receiptId}`, {
                responseType: "blob",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Accept": "application/pdf",
                },
            });

            if (!response || !response.data) throw new Error("🔴 Der Server hat keine Daten zurückgegeben!");

            // إنشاء رابط التنزيل
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${invoiceNumber || "document"}.pdf`);
            document.body.appendChild(link);
            link.click();

            // تنظيف بعد الاستخدام
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("🚨 Fehler beim Hochladen der PDF:", error);
            if (error.response) {
                toast.error(`⚠️ Serverfehler: ${error.response.status} - ${error.response.data?.message || "حدث خطأ!"}`);
            } else {
                toast.error(`⚠️ Datei-Upload fehlgeschlagen: ${error.message}`);
            }
        } finally {
            dispatch(accidentAction.setGetLoading(false)); // إيقاف التحميل
        }
    };
}




export function updateComment(id,text ,title, who) {
  return async (dispatch, getState) => {
    dispatch(accidentAction.setGetLoading(true)); // Set loading state
    try {
      
      const token = sessionStorage.getItem("token");
      const res = await request.put(`/comments/${id}`, { text, title }, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      if (who === "partner") {
        dispatch(accidentAction.updateCommentInPartner({ id, text, title }));
      } else {
        dispatch(accidentAction.updateCommentInAccident({ id, text, title }));
              const { accident } = getState();
      const updatedNotes = accident.lastAccident.notes.map((note) =>
        note._id === id ? { ...note, text: text, title: title } : note
      );

      dispatch(accidentAction.setLastAccident({
        ...accident.lastAccident,
        notes: updatedNotes
      }));
      }
      toast.success("Kommentar erfolgreich aktualisiert."); // Success feedback
    } catch (error) {
      console.error("Fehler beim Aktualisieren des Kommentars:", error.response?.data?.message || error.message);
      toast.error(error.response?.data?.message || "Fehler beim Aktualisieren des Kommentars"); // Error feedback
    } finally {
      dispatch(accidentAction.setGetLoading(false)); // Reset loading state
    }
  };
}

export function deletePartner(id) {
  return async (dispatch) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem('token');
      const res = await request.delete(`/users/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      toast.success("Partner erfolgreich gelöscht"); 
      dispatch(getAllPartner()); 
      dispatch(getAllAdmin()); 
    } catch (error) {
      toast.error(error.response?.data?.message || "Es ist ein Fehler beim Löschen des Partners aufgetreten."); 
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}
export function deleteAdmin(id) {
  return async (dispatch) => {
    dispatch(accidentAction.setGetLoading(true));
    try {
      const token = sessionStorage.getItem('token');
      const res = await request.delete(`/users/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      toast.success("Der Administrator wurde erfolgreich gelöscht."); 
      dispatch(getAllPartner()); 
    } catch (error) {
      toast.error(error.response?.data?.message || "Es ist ein Fehler beim Löschen des Partners aufgetreten."); 
    } finally {
      dispatch(accidentAction.setGetLoading(false));
    }
  };
}
//update Partner

export function updatePartner(id, updatedData, navigate) {
  return async (dispatch) => {
    dispatch(accidentAction.setGetLoading(true)); 

    try {
      const token = sessionStorage.getItem('token');
      
      const res = await request.put(`/users/${id}`, updatedData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`,
        },
      });
      toast.success("Die Daten wurden erfolgreich bearbeitet.");
      dispatch(getAllPartner()); 
      navigate('/partner');
    } catch (error) {
      toast.error(error.response?.data?.message || "Beim Ändern der Daten ist ein Fehler aufgetreten.");
    } finally {
      console.log("Update function finished");
      dispatch(accidentAction.setGetLoading(false)); 
    }
  };
}

